export const DIRECTION = {
  UP: -0b01,
  DOWN: 0b01,
};
